import React, { useEffect } from 'react';

/**
 * OAuth Success Callback Page
 * This page is loaded in the OAuth popup window after successful authentication
 * It extracts the token from URL and closes itself (parent modal will detect this)
 */
const OAuthSuccess = () => {
  useEffect(() => {
    // This page will be automatically detected by the parent window
    // The modal's popup checker will extract the token and close this window
    
    // Optionally, show a brief success message before the window closes
    setTimeout(() => {
      window.close();
    }, 1000);
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'sans-serif',
      backgroundColor: '#f0f9ff'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
        <h2 style={{ color: '#0369a1' }}>Authentication Successful!</h2>
        <p style={{ color: '#64748b' }}>Closing window...</p>
      </div>
    </div>
  );
};

export default OAuthSuccess;
